import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './auth/login/login.component';
import { AthletesComponent } from './athletes/athletes.component';
import { LandingComponent } from './landing/landing.component';
import { MfaCodesComponent } from './mfa-codes/mfa-codes.component';
import { authGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: '', component: LandingComponent },
  { path: 'edit/:id', component: LandingComponent },
  { path: 'login', component: LoginComponent },
  { path: 'athletes', component: AthletesComponent, canActivate: [authGuard] },
  { path: 'mfa-codes', component: MfaCodesComponent, canActivate: [authGuard] },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: 'enabled' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
